export enum planLimitsTypes {
    SHOW_PLAN_LIMITS_POPUP = 'SHOW_PLAN_LIMITS_POPUP',
    HIDE_PLAN_LIMITS_POPUP = 'HIDE_PLAN_LIMITS_POPUP',
    HANDLE_PLAN_LIMIT_POPUP_ERROR = 'HANDLE_PLAN_LIMIT_POPUP_ERROR',
}
